import welcome from '@/utils/welcome';
import {storageManager} from '@/utils/localStorage/manager';
// import { encryptAES, decryptAES } from './utils/crypt';
// import { startViewTransition } from '@/utils/navigation';
// import { startViewTransition } from 'react-router-dom';

// Root contains the main dependencies and providers of the base app
//  - React, ReactDom, RecoilRoot, HelmetProvider, ThemeProvider, MUI-core)
// App contains the main structure of the base app

// These are the two main chunks that are used to render the core structure of the app
// Importing them with Promise.all (by using HTTP/2 multiplexing) we can load them in parallel
// and achieve the best possible performance
const hardReloadOnce = () => {
  const k = 'chunk-reloaded';
  if (sessionStorage.getItem(k)) return;
  sessionStorage.setItem(k, '1');
  window.location.reload();
};

// Vite preload/import error (chunks)
window.addEventListener('vite:preloadError', (event: any) => {
  event.preventDefault?.();
  hardReloadOnce();
});

// Fallback: error global típico del navegador cuando falla React.lazy/import()
window.addEventListener('error', (e) => {
  const msg = String((e as any)?.message || '');
  if (msg.includes('Failed to fetch dynamically imported module')) {
    hardReloadOnce();
  }
});

window.addEventListener('unhandledrejection', (e) => {
  const msg = String((e as any)?.reason?.message || (e as any)?.reason || '');
  if (msg.includes('Failed to fetch dynamically imported module')) {
    hardReloadOnce();
  }
});

storageManager.loadData().then(() => {
  Promise.all([import('@/Root'), import('@/App')])
  .then(([{ default: render }, { default: App }]) => {
    render(App);
  })
});

// welcome message for users in the console
welcome();
// startViewTransition()
// console.log({encryptAES, decryptAES})
// ts(1208)
export {};
